module.exports = [
  '파이리',
  '꼬부기',
  '피카츄',
  '라이츄',
  '버터플',
  '이상해씨',
  '리자몽',
  '거북왕',
  '캐터피',
  '독침붕',
  '피죤',
  '꼬렛',
  '구구',
  '깨비드릴조',
  '아보',
  '모래두지',
  '고지',
  '니드퀸',
  '니드킹',
  '식스테일',
  '나인테일',
  '픽시',
  '삐삐',
  '주뱃',
  '푸린',
  '뚜벅쵸',
  '디그다',
  '고라파덕',
  '성원숭',
  '윈디',
  '발챙이',
  '슈륙챙이',
  '케이시',
  '윤겔라',
  '알통몬',
  '우츠동',
  '모다피',
  '왕눈해',
  '꼬마돌',
  '롱스톤',
  '야돈',
  '코일',
  '파오리',
  '두두',
  '쥬쥬',
  '질퍽이',
  '파르셀',
  '고오스',
  '팬텀',
  '슬리퍼',
  '크랩',
  '킹크랩',
  '찌리리공',
  '붐볼',
  '아라리',
  '나시',
  '탕구리',
  '홍수몬',
  '시라소몬',
  '내루미',
  '또가스',
  '코뿌리',
  '럭키',
  '쏘드라',
  '콘치',
  '별가사리',
  '아쿠스타',
  '마임맨',
  '스라크',
  '루주라',
  '마그마',
  '잉어킹',
  '갸라도스',
  '라프라스',
  '메타몽',
  '이브이',
  '쥬피썬더',
  '폴리곤',
  '부스터',
  '투구푸스',
  '프테라',
  '잠만보',
  '프리져',
  '썬더',
  '미뇽',
  '망나뇽',
  '뮤츠',
  '뮤',
  '치코리타',
  '토게피',
  '세레비',
  '칠색조',
  '뿔카노',
  '에레브',
  '쁘사이저',
  '켄타로스',
  '샤미드',
  '암나이트',
  '신뇽',
  '질뻐기',
];
